import { Skeleton, SkeletonWave } from "app/components/Skeleton";
import React from "react";

const Loading = () => {
  return (
    <React.Fragment>
      <div className="w-full  overflow-hidden ">
        <div className="relative w-full mb-5 ps-[62px]  ">
          <div className=" !p-[10px] h-[30px]  items-center flex flex-row  ">
            <SkeletonWave className="h-[20px] w-full bg-gray-10 rounded-md" />
          </div>
          <div className=" !p-[10px] h-[30px]  items-center flex flex-row">
            <SkeletonWave className="h-[20px] w-full bg-gray-10 rounded-md" />
          </div>
          {Array.from({ length: 15 }).map((_, i) => (
            <div
              key={i}
              className="p-4 border-b border-[#E9ECF2] last:border-b-0 bg-white "
            >
              <div className="flex gap-4 items-center">
                <SkeletonWave className="h-4 w-32 bg-gray-10 w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Loading;
